import { ToastType } from '@components/toast';
import { SystemMaintenanceEventPostRequestBody, SystemMaintenanceEventPostResponse } from '@lio/api-types';
import { systemManagementKeys } from '@services/systemManagement/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { useSnackbar } from 'notistack';

export const useCreateSystemMaintenanceEvent = () => {
  const client = useClient();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const mutationFn = ({ ...request }: SystemMaintenanceEventPostRequestBody) =>
    client
      .post(`system-management/system-maintenance-event`, {
        json: {
          ...request,
        },
      })
      .json<SystemMaintenanceEventPostResponse>();
  const result = useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: systemManagementKeys._search() });
      enqueueSnackbar('System Maintenance Event Created', {
        variant: ToastType.Success,
      });
    },
  });
  return { ...result };
};
